// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { GESTION_OPERATIVA_INITIALIZE_SUB_STATE } from './constants'

const initialSubState = {
  entregaUsados: [],
  actions: [],
  auto: {
    pricingRules: [],
    lineasFinancieras: [],
  },
}

export function initializeSubState(id, state = initialSubState) {
  return {
    type: GESTION_OPERATIVA_INITIALIZE_SUB_STATE,
    data: { id, state },
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_INITIALIZE_SUB_STATE) {
      return {
        ...state,
        [action.data.id]: { ...action.data.state },
      }
  }
  else {
    return state
  }      
}
